export default __webpack_public_path__ + "static/media/dg-icon.cbd9a7ca.svg";